<template>
  <div>
  <v-app-bar app color="header" height="64" style="padding-bottom: 0">
    <!-- Dialog para alterar senha -->
    <v-dialog v-model="alterarSenhaDialog" persistent max-width="600" v-if="!isPlugin">
      <v-card>
        <v-card-title color="primary"><span class="headline" style="color: #4a4a4a">{{ $t("nav.changePassword")
            }}</span></v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field v-model="senha" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'" :label="$t('user.password')" :rules="[validaSenha]"
                  @click:append="show1 = !show1"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field v-model="repetirsenha" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'" label="Repetir Senha" :rules="[validaRepeticaoSenha]"
                  @click:append="show2 = !show2"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="alterarSenha">{{ $t('button.change') }}</v-btn>
          <v-btn color="primary" class="white--text" @click="closeDialog">{{ $t('button.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-btn
      v-if="isModuleNavDrawerRoute"
      icon
      :color="colorInfo"
      class="mr-1"
      :title="moduleNavDrawerTitle"
      :aria-label="moduleNavDrawerTitle"
      @click="openModuleNavDrawer"
    >
      <v-icon :color="colorInfo">mdi-menu</v-icon>
    </v-btn>

    <v-img
      class="mx-2 logo"
      :src="imgSrc + this.logoPath"
      max-height="48"
      :max-width="logoWidth"
      contain
      @click="handleLogoClick"
    ></v-img>

    <v-toolbar-title class="white--text"></v-toolbar-title>

    <v-spacer></v-spacer>
    <v-menu close-on-content-click bottom offset-y v-if="!isMobile()">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mr-2" color="header" depressed v-on="on" v-bind="attrs">
          <v-icon small class="mr-2">mdi-earth</v-icon>
          {{ activeLocale.shortName }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="(loc, l) in locales" :key="`LOC-${l}`" @click="setLocale(loc)">
          <v-list-item-title>{{ `${loc.shortName} ${loc.language}` }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-tooltip v-if="showMenu && !isPlugin" bottom>
      <template v-slot:activator="{ on: tooltipOn, attrs }">
        <v-badge
          :content="operacaoNotificacoesCount"
          :value="operacaoNotificacoesCount > 0"
          color="error"
          overlap
          offset-x="21"
          offset-y="21"
        >
          <v-btn
            v-bind="attrs"
            icon
            class="mr-1"
            v-on="{ ...tooltipOn, click: emitOperacaoNotificacoesClick }"
          >
            <v-icon :color="colorInfo">{{ operacaoNotificacoesVisible ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <span>{{ $t('operation.activeNotifications') }}</span>
    </v-tooltip>
    <SolicitacoesRelatoriosMenu v-if="showMenu && !isPlugin" :color-info="colorInfo" />
    <v-btn v-show="showchevron" @click="$router.go(-1)" title="<" icon>
      <v-icon dark>mdi-chevron-left</v-icon>
    </v-btn>

    <div v-if="showLocalizacao && !isMobile()"
      style="color: black; display: flex; align-items: center; margin-right: 10px; max-width: 30%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
      <v-icon :color="colorInfo" style="margin-right: 5px;">mdi-map-marker</v-icon>
      <span :style="{ color: colorInfo, fontWeight: 'bold' }">{{ this.localizacao }}</span>
    </div>

    <span :style="{ color: colorInfo, fontWeight: 'bold' }" v-if="!showMenu && !isMobile()">
      {{ now }}
    </span>

    <v-btn v-if="isGuiasMotoristaRoute && showMotoristaNovaViagemButton" icon class="mr-1 pa-0"
      :title="$t('guiasMotorista.newGuideTitle')" @click="emitGuiasMotoristaNovaViagem">
      <v-icon :color="colorInfo">mdi-plus</v-icon>
    </v-btn>

    <v-btn v-show="showMenu" icon :color="colorInfo" class="position-relative" title="Menu"
      @click="menuDrawer = !menuDrawer">
      <v-icon :color="colorInfo">mdi-dots-vertical</v-icon>
      <v-badge v-if="ticketsAbertos > 0" :content="ticketsAbertos" color="red" overlap offset-x="35" offset-y="-5">
      </v-badge>
    </v-btn>
  </v-app-bar>

  <v-navigation-drawer v-model="menuDrawer" app right temporary fixed :width="drawerWidth" color="menuBackground"
    class="menuNavbar">

    <template v-slot:prepend>
      <div class="navbar-drawer-header">
        <v-list color="menuBackground" class="py-0">
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar color="indigo">
                <v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
            </v-list-item-avatar>
          </v-list-item>

          <v-list-item link @click="alterarSenhaDialog = true">
            <v-list-item-content>
              <v-list-item-title class="text-h6">{{ nomeusuario }}</v-list-item-title>
              <v-list-item-subtitle style="font-size: 15px">{{ perfilusuario }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <div class="px-3 py-2">
          <v-text-field v-model="menuSearch" :label="$t('system.search')" prepend-inner-icon="mdi-magnify" clearable
            dense hide-details outlined @click:clear="menuSearch = ''"></v-text-field>
        </div>

        <v-divider></v-divider>
      </div>
    </template>

    <v-list color="menuBackground">
      <v-list-item v-show="showMenuPerfilMotorista" link @click="go('/motoristaperfil')">
        <v-list-item-action>
          <v-icon color="menutext">mdi-account</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('guiasMotorista.openProfile') }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="motoristaMensagensNovasCount > 0">
          <v-chip x-small color="red" dark>{{ motoristaMensagensNovasCount }}</v-chip>
        </v-list-item-action>
      </v-list-item>

      <v-divider v-show="showMenuPerfilMotorista"></v-divider>

      <template v-for="sec in filteredSections">
        <template v-if="sec.flat">
          <template v-for="item in sec.items">
            <v-list-item :key="'flat-' + item.path" link @click="go(item.path)">
              <v-list-item-action>
                <v-icon color="menutext">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ resolveLabel(item) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="'flat-div-' + item.path"></v-divider>
          </template>
        </template>

        <template v-else>
          <v-list-group :key="'sec-' + sec.key" :value="searchActive">
            <v-icon v-if="sec.icon" slot="prependIcon" color="menutext">{{ sec.icon }}</v-icon>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(sec.titleKey) }}
                  <v-badge v-if="sec.badge && ticketsAbertos > 0" :content="ticketsAbertos" color="red" inline>
                  </v-badge>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="item in sec.items" :key="item.path" link @click="go(item.path)">
              <v-list-item-action></v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ resolveLabel(item) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group v-for="sg in sec.subGroups" :key="sg.key" sub-group :value="searchActive">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ $t(sg.titleKey) }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="item in sg.items" :key="item.path" link @click="go(item.path)">
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title style="color: #757575;">{{ resolveLabel(item) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-divider :key="'sec-div-' + sec.key"></v-divider>
        </template>
      </template>
    </v-list>

    <template v-slot:append>
      <v-divider v-if="!isPlugin"></v-divider>
      <v-list color="menuBackground" class="py-0">
        <v-list-item link @click="logout(0)" v-if="!isPlugin">
          <v-list-item-action>
            <v-icon color="menutext">mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('button.logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="!isPlugin"></v-divider>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('system.version') }} : {{ versao }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import { VersionNumber, availableLocales, ApiBaseUrl } from "@/constants";
import EventBus from "@/utils/eventBus";
import { resolvePostLoginPath, hasScreenPermission } from "@/utils/postLoginNavigation";
import { isSuperadminUser } from "@/utils/routingModePerfilFilter";
import { canAccessTickets } from "@/utils/ticketPermissions";
import SolicitacoesRelatoriosMenu from "@/components/SolicitacoesRelatoriosMenu.vue";

export default {
  name: "MainNavBar",
  components: {
    SolicitacoesRelatoriosMenu,
  },
  props: {
    titulo: { type: String, default: "" },
  },
  computed: {
    isModuleNavDrawerRoute() {
      const name = this.$route && this.$route.name;
      return name === 'Roteirizacao' || name === 'RecursosOperacao' || name === 'Perfis';
    },
    moduleNavDrawerTitle() {
      if (this.$route && this.$route.name === 'RecursosOperacao') {
        return this.$t('nav.operationResources.title');
      }
      if (this.$route && this.$route.name === 'Perfis') {
        return this.$t('nav.profilesModule.title');
      }
      return this.$t('routePlanning.title');
    },
    showMenuPerfilMotorista() {
      if (this.isPlugin) return false;
      return this.showGuiasMotorista;
    },
    isGuiasMotoristaRoute() {
      return Boolean(this.$route && this.$route.name === 'GuiasMotorista');
    },
    isOperacaoRoute() {
      return Boolean(this.$route && this.$route.name === 'Operacao');
    },
    motoristaMensagensNovasCount() {
      const list = this.motoristaMensagensNovas;
      return Array.isArray(list) ? list.length : 0;
    },
    showMenuViagensPrevistas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ViagensPrevistas') !== -1 || false;
    },
    showMenuVigencias() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Vigencias') !== -1 || false;
    },
    showMenuOperacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Operacao') !== -1 || false;
    },
    showMenuNotificacoesDia() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'NotificacoesDia') !== -1 || false;
    },
    /** Tela única de Tickets: qualquer permissão de visão (painéis e tickets abertos) dá acesso. */
    showMenuTicketsPage() {
      if (this.user?.is_superadmin) return true;
      return canAccessTickets(this.user, this.permissoes);
    },
    showMenuTicketsSolicitacaoCandidatos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TicketsSolicitacaoCandidatos') !== -1 || false;
    },
    showTicketsSuporte() {
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELTicketsSuporte') !== -1 || false;
    },
    showTicketsPorStatus() {
      if (this.user?.is_superadmin) return true;
      // União das permissões: a tela antiga de agendamento redireciona para a unificada.
      return (
        this.permissoes?.findIndex((p) => p.nome_tela === 'RELTicketsPorStatus') !== -1 ||
        this.permissoes?.findIndex((p) => p.nome_tela === 'RELTicketsStatusAgendamento') !== -1 ||
        false
      );
    },
    showMenuAgenciasEmprego() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'AgenciasEmprego') !== -1 || false;
    },
    showMenuTicketAssist() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TicketAssist') !== -1 || false;
    },
    showMenuAtendimentoConfig() {
      if (this.user?.is_superadmin) return true;
      return (
        this.permissoes?.findIndex((p) => p.nome_tela === 'FamiliasAtendimento') !== -1 ||
        this.permissoes?.findIndex((p) => p.nome_tela === 'TiposAtendimento') !== -1 ||
        this.permissoes?.findIndex((p) => p.nome_tela === 'Servicos') !== -1 ||
        false
      );
    },
    showMenuFamiliasAtendimento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'FamiliasAtendimento') !== -1 || false;
    },
    showMenuTiposAtendimento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TiposAtendimento') !== -1 || false;
    },
    showMapaMonitor() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'MapaMonitor') !== -1 || false;
    },
    showMenuRoteirizacao() {
      if (isSuperadminUser(this.user)) return true;
      return hasScreenPermission(this.permissoes, 'Roteirizacao');
    },
    showConsultaPassageiro() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ConsultaPassageiro') !== -1 || false;
    },
    showGuiasMotorista() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'GuiasMotorista') !== -1 || false;
    },
    showStatusEquipamento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'StatusEquipamento') !== -1 || false;
    },
    showMenuResumo() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ResumoOperacao') !== -1 || false;
    },
    showMenuGrade() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'QuadroViagens') !== -1 || false;
    },
    /** Dashboard de embarques (/dashboard): permissão própria, igual à exigida pelo guard de rota. */
    showMenuDashboardEmbarques() {
      if (isSuperadminUser(this.user)) return true;
      return hasScreenPermission(this.permissoes, 'Dashboard');
    },
    showMenuDashboardViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DashboardViagens') !== -1 || false;
    },
    showMenuDashboardPassageiros() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DashboardPassageiros') !== -1 || false;
    },
    showMenuAreas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Areas') !== -1 || false;
    },
    showMenuCadastroChecklistEquipamento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'CadastroChecklistEquipamento') !== -1 || false;
    },
    showMenuPopularChecklistEquipamento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'PopularChecklistEquipamento') !== -1 || false;
    },
    showMenuChecklistsEquipamentosFuncionario() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELChecklistsFuncionario') !== -1 || false;
    },
    showMenuRelHistoricoEquipamento() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELHistoricoEquipamento') !== -1 || false;
    },
    showMenuCercas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Cercas') !== -1 || false;
    },
    showMenuEmpresas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Empresas') !== -1 || false;
    },
    showMenuEquipamentos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Equipamentos') !== -1 || false;
    },
    showMenuTiposEquipamentos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TiposEquipamentos') !== -1 || false;
    },
    showMenuProdutosInternos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ProdutosInternos') !== -1 || false;
    },
    showMenuEquipes() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Equipes') !== -1 || false;
    },
    showMenuEmbarques() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELEmbarques') !== -1 || false;
    },
    showMenuEmbarquesTrecho() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELEmbarquesTrecho') !== -1 || false;
    },
    showMenuEscalas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Escalas') !== -1 || false;
    },
    showMenuFeriados() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Feriados') !== -1 || false;
    },
    showMenuFuncionarios() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Funcionarios') !== -1 || false;
    },
    showMenuGrupos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Grupos') !== -1 || false;
    },
    showMenuGuias() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Guias') !== -1 || false;
    },
    showMenuRecursosOperacao() {
      return this.showMenuLinhas || this.showMenuRotas || this.showMenuCercas || this.showMenuUnidades || this.showMenuAreas;
    },
    showMenuLinhas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Linhas') !== -1 || false;
    },
    showMenuQuadros() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Quadros') !== -1 || false;
    },
    showMenuRotas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Rotas') !== -1 || false;
    },
    showMenuTrechos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Trechos') !== -1 || false;
    },
    showMenuUsuarios() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Usuarios') !== -1 || false;
    },
    showMenuUnidades() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Unidades') !== -1 || false;
    },
    showMenuVeiculos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Veiculos') !== -1 || false;
    },
    showMenuContratosV2() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ContratosSubsidioV2') !== -1 || false;
    },
    showMenuContratoTemplates() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ContratoTemplates') !== -1 || false;
    },
    showMenuTemplatesRecebidos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TemplatesRecebidos') !== -1 || false;
    },
    showMenuIndicadoresReajuste() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'IndicadoresReajuste') !== -1 || false;
    },
    showMenuSubsidioMotorCatalogo() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'SubsidioMotorCatalogo') !== -1 || false;
    },
    showMenuSubsidioScorecard() {
      if (this.setup.has_subsidio_scorecard_melibrasil != 1) return false;
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'SubsidioScorecardMelibrasil') !== -1 || false;
    },
    showMenuControladores() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELLancamentosControladores') !== -1 || false;
    },
    showMenuMotivos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Motivos') !== -1 || false;
    },
    showMenuManutencao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELManutencao') !== -1 || false;
    },
    showMenuVeiculosKm() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELVeiculosKm') !== -1 || false;
    },
    showMenuVeiculosChecklist() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ChecklistVeiculos') !== -1 || false;
    },
    showMenuMensagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Mensagens') !== -1 || false;
    },
    showMenuTemplates() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Templates') !== -1 || false;
    },
    showMenuRelComunicacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELComunicacao') !== -1 || false;
    },
    showMenuAtrasoCercas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELAtrasoCercas') !== -1 || false;
    },
    showMenuAtrasoViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELAtrasoViagens') !== -1 || false;
    },
    showMenuPontualidade() {
      if (isSuperadminUser(this.user) || this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELPontualidade') !== -1 || false;
    },
    showMenuKpisEnderecosExternos() {
      if (isSuperadminUser(this.user) || this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELKpisEnderecosExternos') !== -1 || false;
    },
    showMenuComparacaoETAs() {
      if (isSuperadminUser(this.user) || this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DIAGComparacaoETAs') !== -1 || false;
    },
    showMenuSolicitacoesRelatorios() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'SolicitacoesRelatorios') !== -1 || false;
    },
    showMenuRelatoriosExtenso() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RelatoriosExtenso') !== -1 || false;
    },
    showMenuConfigComunicacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ConfigComunicacao') !== -1 || false;
    },
    showMenuPassageiros() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELPassageirosViagem') !== -1 || false;
    },
    showMenuPessoas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Pessoas') !== -1 || false;
    },
    showMenuCandidatos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Candidatos') !== -1 || false;
    },
    showMenuSituacoes() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Situacoes') !== -1 || false;
    },
    showMenuPlotagem() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELPlotagem') !== -1 || false;
    },
    showMenuPrevistoRealizado() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELPrevistoRealizado') !== -1 || false;
    },
    showMenuTempoDePlaca() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELTempoDePlaca') !== -1 || false;
    },
    showMenuTempoDePlacaServico() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELTempoPlacaServico') !== -1 || false;
    },
    showMenuTempoDeTrecho() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELTempoTrecho') !== -1 || false;
    },
    showMenuComboio() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELComboio') !== -1 || false;
    },
    showMenuCumprimentoRota() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELCumprimentoRota') !== -1 || false;
    },
    showMenuStatusVeiculos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELStatusVeiculos') !== -1 || false;
    },
    showMenuStatusViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELStatusViagens') !== -1 || false;
    },
    // showMenuVeiculosSemGuia() {
    //   if (this.user?.is_superadmin) return true;
    //   return this.permissoes?.findIndex((p) => p.nome_tela === 'RELVeiculosSemGuia') !== -1 || false;
    // },
    showMenuConfig() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Config') !== -1 || false;
    },
    showMenuTemas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Temas') !== -1 || false;
    },
    showMenuRotinas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Rotinas') !== -1 || false;
    },
    showMenuPerfis() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Perfis') !== -1 || false;
    },
    showMenuPermissoes() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Permissoes') !== -1 || false;
    },
    showMenuPermissoesAcesso() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'PermissoesAcesso') !== -1 || false;
    },
    showMenuDiario() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELDiarioBordo') !== -1 || false;
    },
    showMenuVeiculosCercas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'VeiculosCercas') !== -1 || false;
    },
    showMenuRelVeiculosCerca() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELVeiculosAreaMapa') !== -1 || false;
    },
    showMenuHistorico() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELManutencaoHistorico') !== -1 || false;
    },
    showMenuRelMotoristaVeiculo() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELMotoristaVeiculo') !== -1 || false;
    },
    showMenuRelVelocidade() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELVelocidade') !== -1 || false;
    },
    showMenuRelViagensCerca() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELViagensCerca') !== -1 || false;
    },
    showMenuRelHistoricoVeiculo() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELHistoricoVeiculo') !== -1 || false;
    },
    showMenuTarifas() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Tarifas') !== -1 || false;
    },
    showMenuControleSubsidio() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ControleSubsidio') !== -1 || false;
    },
    showMenuRelatorioSubsidio() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELSubsidio') !== -1 || false;
    },
    showMenuConciliacaoViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ConciliacaoViagens') !== -1 || false;
    },
    showMenuRelatorioConciliacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELConciliacao') !== -1 || false;
    },
    showMenuDashboardsBI() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Dashboards') !== -1 || false;
    },
    showMenuClientes() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Clientes') !== -1 || false;
    },
    showMenuTags() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Tags') !== -1 || false;
    },
    showMenuTurnos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Turnos') !== -1 || false;
    },
    showMenuTurnosPassageiros() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TurnosPassageiros') !== -1 || false;
    },
    showMenuTurnosFuncionarios() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TurnosFuncionarios') !== -1 || false;
    },
    showMenuRelatorioMensal() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELSubsidioMensal') !== -1 || false;
    },
    showMenuAcessoQrCode() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELAcessoQrCode') !== -1 || false;
    },
    showMenuConsumoApiExterna() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELConsumoApiExterna') !== -1 || false;
    },
    showMenuDesviosOperacionais() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DIAGDesviosOperacionais') !== -1 || false;
    },
    showMenuInconsistenciaDados() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DIAGInconsistenciaDados') !== -1 || false;
    },
    showMenuAdocaoSistema() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'DIAGAdocaoSistema') !== -1 || false;
    },
    showMenuHistoricoEnvioQrCode() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELHistoricoEnvioQrCode') !== -1 || false;
    },
    showMenuEnvioAutomaticoQrCode() {
      if (isSuperadminUser(this.user)) return true;
      return hasScreenPermission(this.permissoes, 'RELEnvioAutomaticoQrCode');
    },
    showMenuHistoricoRoteirizacao() {
      if (this.user?.is_superadmin) return true;
      return hasScreenPermission(this.permissoes, 'RELHistoricoRoteirizacao')
        || hasScreenPermission(this.permissoes, 'Roteirizacao')
        || hasScreenPermission(this.permissoes, 'RELHistoricoAlteracoesRotas');
    },
    showMenuHistoricoRotas() {
      if (this.user?.is_superadmin) return true;
      // A tela legada de alterações de rotas ainda abre o relatório (só a aba Alterações)
      return hasScreenPermission(this.permissoes, 'RELHistoricoRotas')
        || hasScreenPermission(this.permissoes, 'RELHistoricoAlteracoesRotas');
    },
    showMenuReservasCandidatos() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELReservasCandidatos') !== -1 || false;
    },
    showMenuClassificacoesViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ClassificacoesViagens') !== -1 || false;
    },
    showMenuFechamentoDia() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'FechamentoDia') !== -1 || false;
    },
    showMenuVeiculosGaragem() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'VeiculosGaragem') !== -1 || false;
    },
    showMenuMonitriip() {
      if (!this.setup.has_monitriip) return false;
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Monitriip') !== -1 || false;
    },
    showMenuRelUsuariosPassageiros() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELUsuariosPassageiros') !== -1 || false;
    },
    showMenuRelOcupacaoTurno() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELOcupacaoTurno') !== -1 || false;
    },
    showMenuRelOperacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELOperacao') !== -1 || false;
    },
    showMenuRelPassageirosLinhaDia() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELPassageirosLinhaDia') !== -1 || false;
    },
    showMenuKits() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'Kits') !== -1 || false;
    },
    showMenuTiposKits() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'TiposKits') !== -1 || false;
    },
    showMenuAuditSSFF() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'AUDIntegracaoSSFF') !== -1 || false;
    },
    showMenuAuditSystemLog() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'AUDSystemLog') !== -1 || false;
    },
    showMenuAuditViagens() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'AUDAuditoriaViagens') !== -1 || false;
    },
    showMenuNotasAtualizacao() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'NotasAtualizacao') !== -1 || false;
    },
    showMenuAjuda() {
      return [
        this.showMenuNotasAtualizacao,
      ].some((e) => e);
    },
    showMenuEventosHikvision() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'RELEventosHikvision') !== -1 || false;
    },
    showMenuAtivarEquipamentoNotaFiscal() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'ActivateEquipamentoNotaFiscal') !== -1 || false;
    },
    showMenuNotasFiscais() {
      if (this.user?.is_superadmin) return true;
      return this.permissoes?.findIndex((p) => p.nome_tela === 'NotasFiscais') !== -1 || false;
    },
    showMenuChecklists() {
      return [
        this.showMenuVeiculosChecklist].some((e) => e);
    },
    showMenuChecklistsEquipamentos() {
      return [
        this.showMenuPopularChecklistEquipamento].some((e) => e);
    },
    showMenuDashboards() {
      return [
        this.showMenuDashboardEmbarques,
        this.showMenuDashboardViagens,
        this.showMenuDashboardPassageiros,
        this.showMenuResumo,
        this.showMenuGrade,
        this.showMenuVeiculosCercas].some((e) => e);
    },
    showMenuComunicacao() {
      if (this.user?.is_superadmin) {
        return [
          this.showMenuMensagens,
          this.showMenuRelComunicacao,
          this.showMenuConfigComunicacao,
          this.showMenuTemplates].some((e) => e);
      }
      return [
        this.showMenuMensagens,
        this.showMenuRelComunicacao,
        this.showMenuConfigComunicacao,
        this.showMenuTemplates].some((e) => e) && this.setup.has_comunicacao === 1;
    },
    showMenuCadastros() {
      return [
        this.showMenuAgenciasEmprego,
        this.showMenuAreas,
        this.showMenuEmpresas,
        this.showMenuClientes,
        this.showMenuEquipamentos,
        this.showMenuEscalas,
        this.showMenuFuncionarios,
        this.showMenuFeriados,
        this.showMenuGuias,
        this.showMenuRecursosOperacao,
        this.showMenuQuadros,
        this.showMenuTrechos,
        this.showMenuUsuarios,
        this.showMenuVeiculos,
        this.showMenuReservasCandidatos,
        this.showMenuMotivos,
        this.showMenuPessoas,
        this.showMenuGrupos,
        this.showMenuTags,
        this.showMenuTurnos,
        this.showMenuTurnosPassageiros,
        this.showMenuTurnosFuncionarios,
        this.showMenuClassificacoesViagens,
        this.showMenuFechamentoDia,
        this.showMenuViagensPrevistas,
        this.showMenuNotasFiscais,
        this.showMenuAtivarEquipamentoNotaFiscal,
        this.showMenuEquipes
      ].some((e) => e);
    },
    showMenuTickets() {
      return [
        this.showMenuTicketsPage,
        this.showMenuAtendimentoConfig,
        this.showTicketsPorStatus,
        this.showTicketsSuporte
      ].some((e) => e);
    },
    showMenuRelatorios() {
      return [
        this.showMenuManutencao,
        this.showMenuOperacao,
        this.showMenuPassageiros,
        this.showMenuPlotagem,
        this.showMenuPrevistoRealizado,
        this.showMenuTempoDePlaca,
        this.showMenuTempoDePlacaServico,
        this.showMenuTempoDeTrecho,
        this.showMenuStatusVeiculos,
        this.showMenuComboio,
        this.showMenuStatusViagens,
        this.showMenuDiario,
        this.showMenuCumprimentoRota,
        this.showMenuRelVeiculosCerca,
        this.showMenuHistorico,
        this.showMenuRelVelocidade,
        this.showMenuRelMotoristaVeiculo,
        this.showMenuControladores,
        this.showMenuEmbarques,
        this.showMenuAtrasoCercas,
        this.showMenuAtrasoViagens,
        this.showMenuPontualidade,
        this.showMenuKpisEnderecosExternos,
        this.showMenuAcessoQrCode,
        this.showMenuConsumoApiExterna,
        this.showMenuHistoricoEnvioQrCode,
        this.showMenuEnvioAutomaticoQrCode,
        this.showMenuHistoricoRoteirizacao,
        this.showMenuHistoricoRotas,
        this.showMenuRelUsuariosPassageiros,
        this.showMenuRelOcupacaoTurno,
        this.showMenuRelOperacao,
        this.showMenuRelPassageirosLinhaDia,
        this.showMenuEmbarquesViagens,
        this.showMenuRelViagensCerca,
        // this.showMenuVeiculosSemGuia
      ].some((e) => e);
    },
    showMenuSubsidio() {
      return [
        this.showMenuContratosV2,
        this.showMenuContratoTemplates,
        this.showMenuTemplatesRecebidos,
        this.showMenuIndicadoresReajuste,
        this.showMenuSubsidioMotorCatalogo,
        this.showMenuSubsidioScorecard,
        this.showMenuControleSubsidio,
        this.showMenuRelatorioSubsidio,
        this.showMenuConciliacaoViagens,
        this.showMenuRelatorioConciliacao,
        this.showMenuRelatorioMensal,
        this.showMenuTarifas].some((e) => e) && this.setup.has_subsidio === 1;
    },
    showMenuAplicacoes() {
      return [
        this.showConsultaPassageiro,
        this.showGuiasMotorista,
        this.showMenuOperacao,
        this.showStatusEquipamento,
        this.showMapaMonitor,
        this.showMenuRoteirizacao,
        this.showMenuTicketAssist].some((e) => e);
    },
    showMenuGestao() {
      return [
        this.showMenuRelatorios,
        this.showMenuChecklists,
        this.showMenuChecklistsEquipamentos,
        this.showMenuSolicitacoesRelatorios,
        this.showMenuRelatoriosExtenso].some((e) => e);
    },
    showMenuSistema() {
      return [
        this.showMenuPerfis,
        this.showMenuPermissoes,
        this.showMenuPermissoesAcesso,
        this.showMenuConfig,
        this.showMenuRotinas,
        this.showMenuTemas].some((e) => e);
    },
    showMenuAuditoria() {
      return [
        this.showMenuAuditSSFF,
        this.showMenuAuditSystemLog,
        this.showMenuAuditViagens,
      ].some((e) => e);
    },
    showMenuDiagnosticos() {
      return [
        this.showMenuDesviosOperacionais,
        this.showMenuInconsistenciaDados,
        this.showMenuAdocaoSistema,
        this.showMenuComparacaoETAs,
      ].some((e) => e);
    },
    imgSrc() {
      return `${ApiBaseUrl}/`
    },
    activeLocale() {
      if (this.locales.length === 0) {
        return null;
      }

      return this.locales.find((l) => l.code === this.$i18n.locale);
    },
    logoWidth() {
      if (this.isMobile()) {
        return "90%";
      }

      if (this.$vuetify?.breakpoint?.mdAndDown) {
        return "280px";
      }

      return "300px";
    },
    drawerWidth() {
      if (this.isMobile()) {
        return "clamp(240px, 85vw, 360px)";
      }

      if (this.$vuetify?.breakpoint?.mdAndDown) {
        return "320px";
      }

      return "360px";
    },
    showMotoristaNovaViagemButton() {
      this.populaConfiguracoes();
      if (Number(this.motoristaCriaViagem) !== 1) {
        return false;
      }
      return this.motoristaJornadaAtiva;
    },
    menuSections() {
      return [
        {
          key: "top", flat: true, show: true,
          items: [
            { labelKey: "nav.main", icon: "mdi-home", path: "/operacao", show: this.showMenuOperacao },
            { labelKey: "operation.notificationsTitle", icon: "mdi-bell-ring-outline", path: "/notificacoesdia", show: this.showMenuNotificacoesDia },
            { raw: "Monitriip", icon: "mdi-bus-alert", path: "/monitriip", show: this.showMenuMonitriip },
            { labelKey: "nav.dashboards", icon: "mdi-chart-box", path: "/dashboards", show: this.showMenuDashboardsBI },
          ],
        },
        {
          key: "realtime", titleKey: "nav.realTime.title", icon: "mdi-clock-alert-outline", show: this.showMenuDashboards,
          items: [
            { labelKey: "nav.realTime.boarding", path: "/dashboard", show: this.showMenuDashboardEmbarques },
            { labelKey: "nav.realTime.grid", path: "/quadroviagens", show: this.showMenuGrade },
            { labelKey: "nav.realTime.summary", path: "/resumo", show: this.showMenuResumo },
            { labelKey: "nav.realTime.vehiclesInGarage", path: "/veiculosgaragem", show: this.showMenuVeiculosGaragem },
            { labelKey: "nav.realTime.vehiclesInGeofences", path: "/veiculoscercas", show: this.showMenuVeiculosCercas },
            { labelKey: "nav.realTime.trips", path: "/dashboardviagens", show: this.showMenuDashboardViagens },
            { labelKey: "nav.realTime.passengers", path: "/dashboardpassageiros", show: this.showMenuDashboardPassageiros },
          ],
        },
        {
          key: "cadastros", titleKey: "nav.registration.title", icon: "mdi-database", show: this.showMenuCadastros,
          items: [
            { labelKey: "crudAgenciasEmprego.menuTitle", path: "/agencias-emprego", show: this.showMenuAgenciasEmprego },
            { labelKey: "nav.registration.candidates", path: "/candidatos", show: this.showMenuCandidatos },
            { labelKey: "nav.registration.tripClassifications", path: "/classificacoesviagens", show: this.showMenuClassificacoesViagens },
            { labelKey: "nav.registration.companies", path: "/empresas", show: this.showMenuEmpresas },
            { labelKey: "nav.registration.clients", path: "/clientes", show: this.showMenuClientes },
            { labelKey: "nav.registration.logbook", path: "/motivos", show: this.showMenuMotivos },
            { labelKey: "nav.registration.equipments", path: "/equipamentos", show: this.showMenuEquipamentos },
            { labelKey: "nav.registration.equipmentTypes", path: "/tiposequipamentos", show: this.showMenuTiposEquipamentos },
            { labelKey: "nav.registration.kitTypes", path: "/tiposkits", show: this.showMenuTiposKits },
            { labelKey: "nav.registration.internalProducts", path: "/produtosinternos", show: this.showMenuProdutosInternos },
            { labelKey: "nav.registration.closingDay", path: "/fechamentodia", show: this.showMenuFechamentoDia },
            { labelKey: "nav.registration.teams", path: "/equipes", show: this.showMenuEquipes },
            { labelKey: "nav.registration.serviceOrders", path: "/guias", show: this.showMenuGuias },
            { labelKey: "nav.registration.schedules", path: "/escalas", show: this.showMenuEscalas },
            { labelKey: "nav.registration.holidays", path: "/feriados", show: this.showMenuFeriados },
            { labelKey: "nav.registration.employees", path: "/funcionarios", show: this.showMenuFuncionarios },
            { labelKey: "nav.registration.groups", path: "/grupos", show: this.showMenuGrupos },
            { labelKey: "nav.registration.lines", path: "/linhas", show: this.showMenuRecursosOperacao },
            { labelKey: "nav.registration.routes", path: "/rotas", show: this.showMenuRecursosOperacao },
            { labelKey: "nav.registration.geofences", path: "/cercas", show: this.showMenuRecursosOperacao },
            { labelKey: "nav.registration.units", path: "/unidades", show: this.showMenuRecursosOperacao },
            { labelKey: "nav.registration.areas", path: "/areas", show: this.showMenuAreas },
            { labelKey: "nav.notasFiscais", path: "/notas-fiscais", show: this.showMenuNotasFiscais },
            { labelKey: "notasFiscais.activateSetCode.title", path: "/ativar-equipamento-nota-fiscal", show: this.showMenuAtivarEquipamentoNotaFiscal },
            { labelKey: "nav.registration.passengers", path: "/pessoas", show: this.showMenuPessoas },
            { labelKey: "nav.registration.timetables", path: "/quadros", show: this.showMenuQuadros },
            { labelKey: "candidateReservations.report.title", path: "/reservas-candidatos", show: this.showMenuReservasCandidatos },
            { labelKey: "nav.registration.situations", path: "/situacoes", show: this.showMenuSituacoes },
            { labelKey: "nav.registration.tags", path: "/tags", show: this.showMenuTags },
            { labelKey: "nav.registration.shifts", path: "/turnos", show: this.showMenuTurnos },
            { labelKey: "nav.registration.shiftsPassengers", path: "/turnospassageiros", show: this.showMenuTurnosPassageiros },
            { labelKey: "nav.registration.shiftsEmployees", path: "/turnosfuncionarios", show: this.showMenuTurnosFuncionarios },
            { labelKey: "nav.registration.stretches", path: "/trechos", show: this.showMenuTrechos },
            { labelKey: "nav.registration.users", path: "/usuarios", show: this.showMenuUsuarios },
            { labelKey: "nav.registration.vehicles", path: "/veiculos", show: this.showMenuVeiculos },
            { labelKey: "nav.registration.validities", path: "/vigencia", show: this.showMenuVigencias },
            { raw: "Viagens Previstas", path: "/viagensprevistas", show: this.showMenuViagensPrevistas },
          ],
        },
        {
          key: "subsidio", titleKey: "nav.subsidy.title", icon: "mdi-currency-usd", show: this.showMenuSubsidio,
          items: [
            { labelKey: "nav.subsidy.conciliacaoTrip", path: "/conciliacaoviagens", show: this.showMenuConciliacaoViagens },
            { labelKey: "nav.subsidy.contractV2", path: "/contratos-subsidio", show: this.showMenuContratosV2 },
            { labelKey: "nav.subsidy.contractTemplates", path: "/contrato-templates", show: this.showMenuContratoTemplates },
            { labelKey: "nav.subsidy.receivedTemplates", path: "/templates-recebidos", show: this.showMenuTemplatesRecebidos },
            { labelKey: "nav.subsidy.adjustmentIndicators", path: "/indicadores-reajuste", show: this.showMenuIndicadoresReajuste },
            { labelKey: "nav.subsidy.motorCatalog", path: "/subsidio-motor-catalogo", show: this.showMenuSubsidioMotorCatalogo },
            { labelKey: "nav.subsidy.scorecardMelibrasil", path: "/subsidio-scorecard-melibrasil", show: this.showMenuSubsidioScorecard },
            { labelKey: "nav.subsidy.VehicleControl", path: "/controlesubsidio", show: this.showMenuControleSubsidio },
            { labelKey: "nav.subsidy.relCompensation", path: "/relsubsidio", show: this.showMenuRelatorioSubsidio },
            { labelKey: "nav.subsidy.relConciliation", path: "/relconciliacao", show: this.showMenuRelatorioConciliacao },
            { labelKey: "nav.subsidy.relMonthly", path: "/subsidiomensal", show: this.showMenuRelatorioMensal },
            { labelKey: "nav.subsidy.Tarifs", path: "/tarifas", show: this.showMenuTarifas },
          ],
        },
        {
          key: "tickets", titleKey: "nav.tickets.title", icon: "mdi-ticket", badge: true, show: this.showMenuTickets,
          items: [
            { labelKey: "nav.tickets.title", path: "/tickets", show: this.showMenuTicketsPage },
            { labelKey: "crudAtendimentoConfig.title", path: "/atendimentoconfig", show: this.showMenuAtendimentoConfig },
            { labelKey: "ticketPorStatus.title", path: "/relticketsporstatus", show: this.showTicketsPorStatus },
            { labelKey: "ticketSuporteFluxo.tituloRelatorio", path: "/relticketssuporte", show: this.showTicketsSuporte },
          ],
        },
        {
          key: "checklistsEquip", titleKey: "nav.checklists.equipments", icon: "mdi-clipboard-list", show: this.showMenuChecklistsEquipamentos,
          items: [
            { labelKey: "nav.checklists.checklistEquipamento", path: "/cadastrochecklistequipamento", show: this.showMenuCadastroChecklistEquipamento },
            { labelKey: "nav.checklists.popularChecklistEquipamento", path: "/popularchecklistequipamento", show: this.showMenuPopularChecklistEquipamento },
            { labelKey: "nav.checklists.relHistoricoEquipamento", path: "/relhistoricoequipamento", show: this.showMenuRelHistoricoEquipamento },
          ],
        },
        {
          key: "aplicacoes", titleKey: "nav.applications", icon: "mdi-apps", show: this.showMenuAplicacoes,
          items: [
            { labelKey: "nav.consultPassenger", path: "/consultapassageiro", show: this.showConsultaPassageiro },
            { labelKey: "nav.guiasMotoristaDia", path: "/guiasmotorista", show: this.showGuiasMotorista },
            { labelKey: "nav.dashboardNotifications", path: "/dashboardnotificacoes", show: this.showMenuOperacao },
            { labelKey: "nav.equipStatus", path: "/statusequipamento", show: this.showStatusEquipamento },
            { labelKey: "nav.monitor", path: "/mapamonitor", show: this.showMapaMonitor },
            { labelKey: "nav.route.title", path: "/roteirizacao", show: this.showMenuRoteirizacao },
            { labelKey: "ticket.assist.menuTitle", path: "/ticket-assist", show: this.showMenuTicketAssist },
            { labelKey: "nav.realTime.videowall", path: "/videowall", show: true },
          ],
        },
        {
          key: "gestao", titleKey: "nav.management", icon: "mdi-chart-box", show: this.showMenuGestao,
          items: [
            { labelKey: "nav.reportRequests", path: "/solicitacoesrelatorios", show: this.showMenuSolicitacoesRelatorios },
            { labelKey: "nav.extensiveReports", path: "/relatoriosextenso", show: this.showMenuRelatoriosExtenso },
          ],
          subGroups: [
            {
              key: "checklists", titleKey: "nav.checklists.title", show: this.showMenuChecklists,
              items: [
                { labelKey: "nav.checklists.vehicles", path: "/inspecaoveiculo", show: this.showMenuVeiculosChecklist },
              ],
            },
            {
              key: "relatorios", titleKey: "nav.reports.title", show: this.showMenuRelatorios,
              items: [
                { labelKey: "nav.reports.qrCodeAccess", path: "/relacessoqrcode", show: this.showMenuAcessoQrCode },
                { labelKey: "nav.reports.delayByGeofence", path: "/relatrasocercas", show: this.showMenuAtrasoCercas },
                { labelKey: "nav.reports.tripDelay", path: "/relatrasoviagens", show: this.showMenuAtrasoViagens },
                { labelKey: "nav.reports.convoy", path: "/relcomboio", show: this.showMenuComboio },
                { labelKey: "nav.reports.apiConsumption", path: "/relconsumoapi", show: this.showMenuConsumoApiExterna },
                { labelKey: "nav.reports.routeFulfillment", path: "/relcumprimentorota", show: this.showMenuCumprimentoRota },
                { labelKey: "nav.reports.logbook", path: "/reldiariobordo", show: this.showMenuDiario },
                { labelKey: "nav.reports.boarding", path: "/relembarques", show: this.showMenuEmbarques },
                { labelKey: "nav.reports.boardingByStretch", path: "/relembarquestrecho", show: this.showMenuEmbarquesTrecho },
                { labelKey: "nav.reports.qrCodeAutoSend", path: "/relenvioautomaticoqrcode", show: this.showMenuEnvioAutomaticoQrCode },
                { labelKey: "nav.reports.hikvisionEvents", path: "/releventoshikvision", show: this.showMenuEventosHikvision },
                { labelKey: "nav.reports.qrCodeSendHistory", path: "/relhistoricoenvioqrcode", show: this.showMenuHistoricoEnvioQrCode },
                { labelKey: "nav.reports.equipHistory", path: "/relmanutencaohistorico", show: this.showMenuHistorico },
                { labelKey: "nav.reports.routingHistoryTimeline", path: "/relhistoricoroteirizacao", show: this.showMenuHistoricoRoteirizacao },
                { labelKey: "nav.reports.routesHistory", path: "/relhistoricorotas", show: this.showMenuHistoricoRotas },
                { labelKey: "nav.reports.vehicleHistory", path: "/relhistoricoveiculo", show: this.showMenuRelHistoricoVeiculo },
                { labelKey: "nav.reports.externalAddressKpis", fallback: "KPIs de endereços externos", path: "/relkpisenderecosexternos", show: this.showMenuKpisEnderecosExternos },
                { labelKey: "nav.reports.vehicleKm", path: "/relveiculoskm", show: this.showMenuVeiculosKm },
                { labelKey: "nav.reports.realTimeKm", path: "/relkmtemporeal", show: this.showMenuVeiculosKm },
                { labelKey: "nav.reports.controllersTrips", path: "/relcontroladores", show: this.showMenuControladores },
                { labelKey: "nav.reports.equipMaintenance", path: "/relmanutencao", show: this.showMenuManutencao },
                { labelKey: "nav.reports.notifications", path: "/relnotificacoes", show: this.showMenuOperacao },
                { labelKey: "nav.reports.passengers", path: "/relpassageirosviagem", show: this.showMenuPassageiros },
                { labelKey: "nav.reports.passengersByLineDay", path: "/relpassageiroslinhadia", show: this.showMenuRelPassageirosLinhaDia },
                { labelKey: "nav.reports.replay", path: "/relplotagem", show: this.showMenuPlotagem },
                { labelKey: "nav.reports.punctuality", fallback: "Pontualidade", path: "/relpontualidade", show: true },
                { labelKey: "nav.reports.timetableFulfillment", path: "/relprevistorealizado", show: this.showMenuPrevistoRealizado },
                { labelKey: "nav.reports.operacion", path: "/reloperacao", show: this.showMenuRelOperacao },
                { labelKey: "nav.reports.vehicleCommStatus", path: "/relstatusveiculos", show: this.showMenuStatusVeiculos },
                { labelKey: "nav.reports.tripStatus", path: "/relstatusviagens", show: this.showMenuStatusViagens },
                { labelKey: "nav.reports.occupancyByShift", path: "/relocupacaoporturno", show: this.showMenuRelOcupacaoTurno },
                { labelKey: "nav.reports.timeBetweenTrips", path: "/reltempodeplaca", show: this.showMenuTempoDePlaca },
                { labelKey: "nav.reports.timeBetweenTripsByService", path: "/reltempodeplacaservico", show: this.showMenuTempoDePlacaServico },
                { labelKey: "nav.reports.stretchTime", path: "/reltempotrecho", show: this.showMenuTempoDeTrecho },
                { labelKey: "nav.reports.passengersUsers", path: "/relusuariospassageiros", show: this.showMenuRelUsuariosPassageiros },
                { labelKey: "nav.reports.vehiclesInGeofences", path: "/relveiculosareamapa", show: this.showMenuRelVeiculosCerca },
                { labelKey: "nav.reports.velocity", path: "/relvelocidade", show: this.showMenuRelVelocidade },
                { labelKey: "nav.reports.driverVehicle", path: "/relmotoristaveiculo", show: this.showMenuRelMotoristaVeiculo },
                { labelKey: "nav.reports.tripsByGeofence", path: "/relviagenscerca", show: this.showMenuRelViagensCerca },
              ],
            },
          ],
        },
        {
          key: "sistema", titleKey: "nav.configurations.system", icon: "mdi-cog", show: this.showMenuSistema,
          items: [
            { labelKey: "nav.profiles", path: "/perfis", show: this.showMenuPerfis },
            { labelKey: "nav.permissions", path: "/permissoes", show: this.showMenuPermissoes },
            { labelKey: "nav.accessPermissions", path: "/permissoes-acesso", show: this.showMenuPermissoesAcesso },
            { labelKey: "nav.configurations.title", path: "/config", show: this.showMenuConfig },
            { labelKey: "nav.routines", path: "/rotinas", show: this.showMenuRotinas },
            { labelKey: "nav.configurations.theme", path: "/aparencia", show: this.showMenuTemas },
          ],
        },
        {
          key: "comunicacao", titleKey: "nav.communication.title", icon: "mdi-email-fast", show: this.showMenuComunicacao,
          items: [
            { labelKey: "nav.communication.sendMessages", path: "/mensagens", show: this.showMenuMensagens },
            { labelKey: "nav.communication.templates", path: "/templates", show: this.showMenuTemplates },
            { labelKey: "nav.communication.reports", path: "/relcomunicacao", show: this.showMenuRelComunicacao },
          ],
        },
        {
          key: "auditoria", titleKey: "nav.audit.title", icon: "mdi-shield-check", show: this.showMenuAuditoria,
          items: [
            { labelKey: "nav.audit.SSFFIntegration", path: "/audit/integracaossff", show: this.showMenuAuditSSFF },
            { labelKey: "nav.audit.systemLog", path: "/audit/systemlog", show: this.showMenuAuditSystemLog },
            { labelKey: "nav.audit.tripAudit", path: "/audit/auditoriaviagens", show: this.showMenuAuditViagens },
          ],
        },
        {
          key: "diagnosticos", titleKey: "nav.diagnostics.title", icon: "mdi-stethoscope", show: this.showMenuDiagnosticos,
          items: [
            { labelKey: "nav.diagnostics.operationalDeviations", path: "/diagnosticos/desviosoperacionais", show: this.showMenuDesviosOperacionais },
            { labelKey: "nav.diagnostics.dataInconsistencies", path: "/diagnosticos/inconsistenciadados", show: this.showMenuInconsistenciaDados },
            { labelKey: "nav.diagnostics.systemAdoption", path: "/diagnosticos/adocaosistema", show: this.showMenuAdocaoSistema },
            { labelKey: "nav.diagnostics.etaComparison", path: "/diagnosticos/comparacaoetas", show: this.showMenuComparacaoETAs },
          ],
        },
        {
          key: "ajuda", titleKey: "nav.help.title", icon: "mdi-help-circle", show: this.showMenuAjuda,
          items: [
            { labelKey: "nav.help.updateNotes", path: "/notas-atualizacao", show: this.showMenuNotasAtualizacao },
          ],
        },
      ];
    },
    normalizedSearch() {
      return this.normalize(this.menuSearch);
    },
    searchActive() {
      return this.normalizedSearch.length > 0;
    },
    filteredSections() {
      const q = this.normalizedSearch;
      const sections = [];

      for (const sec of this.menuSections) {
        if (!sec.show) continue;

        const secTitleMatch = !q || (sec.titleKey && this.normalize(this.$t(sec.titleKey)).includes(q));

        const items = (sec.items || [])
          .filter((it) => it.show)
          .filter((it) => !q || secTitleMatch || this.itemMatches(it));

        const subGroups = [];
        for (const sg of (sec.subGroups || [])) {
          if (!sg.show) continue;
          const sgTitleMatch = secTitleMatch || (sg.titleKey && this.normalize(this.$t(sg.titleKey)).includes(q));
          const sgItems = (sg.items || [])
            .filter((it) => it.show)
            .filter((it) => !q || sgTitleMatch || this.itemMatches(it));
          if (sg.key === "relatorios") {
            const locale = this.$i18n?.locale;
            sgItems.sort((a, b) =>
              this.resolveLabel(a).localeCompare(this.resolveLabel(b), locale, { sensitivity: "base" })
            );
          }
          if (!q || sgItems.length > 0 || sgTitleMatch) {
            subGroups.push({ ...sg, items: sgItems });
          }
        }

        const hasContent = items.length > 0 || subGroups.length > 0;
        const keep = sec.flat ? hasContent : (!q ? true : (hasContent || secTitleMatch));
        if (keep) {
          sections.push({ ...sec, items, subGroups });
        }
      }

      return sections;
    }
  },
  data: () => ({
    logoPath: null,
    colorInfo: null,
    isUrbano: true,
    isTabClosed: false,
    showchevron: false,
    showMenu: true,
    menuDrawer: false,
    menuSearch: "",
    versao: "",
    alterarSenhaDialog: false,
    user: null,
    permissoes: null,
    show1: false,
    show2: false,
    senha: null,
    nomeusuario: "",
    perfilusuario: "",
    repetirsenha: null,
    formValidado: true,
    menuBackground: null,
    now: null,
    clockTimeout: null,
    ticketsAbertos: 0,
    setup: {
      id_modo: null,
      descricao_modo: null,
      has_eta: 0,
      has_google_chat: 0,
      has_validador: 0,
      has_controle_embarque: 0,
      has_comunicacao: 0,
      has_subsidio: 0,
      has_condicao_climatica: 0,
      has_monitriip: 0,
      has_isapi: 0,
      suite_comunicacao_default: null
    },
    motoristaCriaViagem: 0,
    showLocalizacao: false,
    localizacao: null,
    locales: [],
    isPlugin: false,
    motoristaMensagensNovas: [],
    motoristaMensagensPollId: null,
    motoristaIdPessoa: null,
    motoristaJornadaAtiva: false,
    operacaoNotificacoesCount: 0,
    operacaoNotificacoesVisible: false,
  }),
  watch: {
    isTabClosed(newValue) {
      if (newValue) {
        this.logout(1);
      }
    },
    user(newValue) {
      if (newValue != null) {
        this.nomeusuario = this.user.nome_usuario;
      }
    },
    $route(to) {
      this.applyRouteNavMenuVisibility(to);
      this.syncMotoristaMensagensPolling(to);
    },
  },
  mounted() {
    this.$root.$on("toogleMenu", (value) => {
      this.showMenu = value;
    });

    this.$root.$on("setUserName", (value) => {
      this.nomeusuario = value;
    });

    this.$root.$on("setPerfilUsuario", (value) => {
      this.perfilusuario = value;
    });

    this.$root.$on("setUser", (value) => {
      this.user = value;
      if (value) {
        this.populaSetup();
        this.populaConfiguracoes();
        this.carregarTicketsAbertos();
      }
    });

    this.$root.$on("setPermissoes", (value) => {
      this.permissoes = Array.isArray(value) ? value : [];
    });

    this.$root.$on("atualizarTicketsAbertos", () => {
      this.carregarTicketsAbertos();
    });

    this.$root.$on("setLocalizacao", (value) => {
      this.localizacao = value;
      this.showLocalizacao = value !== null;
    });

    this.$root.$on("logoChanged", (newLogoPath) => {
      this.logoPath = newLogoPath;
    });

    this.$root.$on("setPlugin", (value) => {
      this.isPlugin = value;
    });

    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("load", this.handleLoad);
    this.syncMotoristaMensagensPolling(this.$route);
    EventBus.$on('motorista-jornada-state', this.onMotoristaJornadaState);
    EventBus.$on('operacao-notificacoes-count', this.onOperacaoNotificacoesCount);
    EventBus.$on('operacao-notificacoes-visible', this.onOperacaoNotificacoesVisible);
  },
  beforeDestroy() {
    EventBus.$off('motorista-jornada-state', this.onMotoristaJornadaState);
    EventBus.$off('operacao-notificacoes-count', this.onOperacaoNotificacoesCount);
    EventBus.$off('operacao-notificacoes-visible', this.onOperacaoNotificacoesVisible);
    this.$root.$off("logoChanged");
    this.$root.$off("themeChanged");
    this.$root.$off("forcePageUpdate");

    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener("load", this.handleLoad);
    clearInterval(this.clockTimeout);
    this.clearMotoristaMensagensPollTimer();
  },
  created() {
    this.versao = VersionNumber;
    this.locales = availableLocales;
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.permissoes = this.readPermissoesFromSession();
    this.applyRouteNavMenuVisibility(this.$route);
    this.menuBackground = this.$vuetify.theme.themes.light.menuBackground;
    this.setInfoColor(this.$vuetify.theme.themes.light.header);
    this.logoPath = sessionStorage.getItem("logo");
    this.populaSetup();
    this.tickClock();
    this.populaSetup();
    this.carregarTicketsAbertos();
  },
  methods: {
    openModuleNavDrawer() {
      EventBus.$emit('module-nav-drawer-toggle');
    },
    readPermissoesFromSession() {
      try {
        const raw = sessionStorage.getItem("permissoes");
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    normalize(value) {
      return (value || "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },
    resolveLabel(item) {
      if (item.raw) return item.raw;
      const translated = this.$t(item.labelKey);
      return translated || item.fallback || translated;
    },
    itemMatches(item) {
      if (!this.normalizedSearch) return true;
      return this.normalize(this.resolveLabel(item)).includes(this.normalizedSearch);
    },
    go(path) {
      this.$router.push({ path });
      this.menuDrawer = false;
    },
    applyRouteNavMenuVisibility(route) {
      if (!route || !route.meta) {
        this.showMenu = true;
        return;
      }
      if (route.meta.hideNavMenu) {
        this.showMenu = false;
        this.menuDrawer = false;
        return;
      }
      if (!route.meta.requiresAuth) {
        this.showMenu = false;
        this.menuDrawer = false;
        return;
      }
      this.showMenu = true;
    },
    emitGuiasMotoristaNovaViagem() {
      EventBus.$emit('guias-motorista-nav-nova-viagem');
    },
    emitOperacaoNotificacoesClick() {
      EventBus.$emit('operacao-notificacoes-click');
    },
    onOperacaoNotificacoesCount(count) {
      const n = Number(count);
      this.operacaoNotificacoesCount = Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
    },
    onOperacaoNotificacoesVisible(visible) {
      this.operacaoNotificacoesVisible = Boolean(visible);
    },
    onMotoristaJornadaState(active) {
      this.motoristaJornadaAtiva = Boolean(active);
    },
    clearMotoristaMensagensPollTimer() {
      if (this.motoristaMensagensPollId != null) {
        clearTimeout(this.motoristaMensagensPollId);
        this.motoristaMensagensPollId = null;
      }
    },
    isMotoristaAppRoute(route) {
      const r = route || this.$route;
      return Boolean(
        r && (r.name === 'GuiasMotorista' || r.name === 'JornadaMotorista' || r.name === 'PerfilMotorista'),
      );
    },
    syncMotoristaMensagensPolling(route) {
      const r = route || this.$route;
      if (!this.isMotoristaAppRoute(r) || this.isPlugin || !this.showGuiasMotorista) {
        this.clearMotoristaMensagensPollTimer();
        this.motoristaMensagensNovas = [];
        this.motoristaIdPessoa = null;
        this.motoristaJornadaAtiva = false;
        return;
      }
      this.loadMotoristaPessoaForUnreadBadge();
    },
    loadMotoristaPessoaForUnreadBadge() {
      this.clearMotoristaMensagensPollTimer();
      const token = sessionStorage.getItem('api');
      let idUsuario = null;
      try {
        const raw = sessionStorage.getItem('user');
        if (raw) {
          const u = JSON.parse(raw);
          idUsuario = u.id_usuario != null ? u.id_usuario : null;
        }
      } catch (e) {
        idUsuario = null;
        console.error(e);
      }
      if (!token || idUsuario == null) {
        this.motoristaMensagensNovas = [];
        return;
      }
      apiController.request(apiController.endpoints.getPessoaporusuario, {
        params: { id: idUsuario },
        onSuccess: (response) => {
          if (!this.isMotoristaAppRoute()) return;
          const row = Array.isArray(response.data) ? response.data[0] : null;
          const idPessoa = row && row.id_pessoa != null ? row.id_pessoa : null;
          this.motoristaIdPessoa = idPessoa;
          if (idPessoa) {
            this.fetchMotoristaMensagensNovas();
          } else {
            this.motoristaMensagensNovas = [];
          }
        }
      })
    },
    fetchMotoristaMensagensNovas() {
      if (!this.isMotoristaAppRoute()) return;
      const token = sessionStorage.getItem('api');
      if (!token || !this.motoristaIdPessoa) return;
      apiController.request(apiController.endpoints.getMensagensnaolidaspordestinatario, {
        params: { id: this.motoristaIdPessoa },
        onSuccess: (response) => {
          if (!this.isMotoristaAppRoute()) return;
          this.motoristaMensagensNovas = Array.isArray(response.data) ? response.data : [];
          this.clearMotoristaMensagensPollTimer();
          this.motoristaMensagensPollId = setTimeout(() => this.fetchMotoristaMensagensNovas(), 60000);
        }
      })
    },
    atualizaLogo() {
      this.logoPath = sessionStorage.getItem("logo");
    },
    closeDialog() {
      this.show1 = false;
      this.show2 = false;
      this.$refs.form.resetValidation();
      this.senha = null;
      this.repetirsenha = null;
      this.alterarSenhaDialog = false;
    },
    isMobile() {
      if (this.$vuetify?.breakpoint) {
        return this.$vuetify.breakpoint.smAndDown;
      }

      if (typeof window !== 'undefined') {
        return window.innerWidth < 960;
      }

      if (typeof navigator !== 'undefined') {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      }

      return false;
    },
    tickClock() {
      this.now = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
      this.clockTimeout = setTimeout(this.tickClock, 1000);
    },
    alterarSenha() {
      this.$refs.form.validate();
      if (this.formValidado) {
        var user = JSON.parse(sessionStorage.getItem("user"));
        var token = sessionStorage.getItem("api");
        if (user == null || token == null) {
          EventBus.$emit('show-error', {
            error: {
              message: this.$t('system.messages.accessDenied'),
              response: { status: 401 }
            }
          });
          return false;
        } else {
          var registro = {
            id_usuario: user.id_usuario,
            senha: this.senha,
            repetirsenha: this.repetirsenha,
          };
          apiController.request(apiController.endpoints.alteraSenha, {
        data: registro,
        silent: true,
        onSuccess: (response) => {
          EventBus.$emit('show-alert', {
                mensagem: response.data.erro ? this.$t('system.messages.changePasswordError') : this.$t('system.messages.changePasswordSuccess'),
                tipo: response.data.erro ? 'error' : 'success'
              });
              this.senha = null;
              this.repetirsenha = null;
              this.$refs.form.resetValidation();
        },
        onError: () => {
          this.alterarSenhaDialog = false;
              this.show1 = false;
              this.show2 = false;
              this.senha = null;
              this.repetirsenha = null;
        }
      })
        }
      }
    },
    validaSenha() {
      if (this.senha == null) {
        return this.$t('system.messages.pswdRequired');
      } else {
        if (this.senha.length === 0) {
          return this.$t('system.messages.pswdRequired');
        } else {
          if (
            !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{12,}$/.test(
              this.senha
            )
          ) {
            return this.$t('system.messages.invalidPswd');
          } else {
            return true;
          }
        }
      }
    },
    validaRepeticaoSenha() {
      if (
        this.repetirsenha == null ||
        this.repetirsenha == "" ||
        this.repetirsenha.length < 1
      ) {
        return this.$t('system.messages.pswdRequired');
      } else {
        if (this.senha != this.repetirsenha) {
          return this.$t('system.messages.differentPswds');
        } else {
          return true;
        }
      }
    },
    handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    handleLoad() {
      const navigationEntries = performance.getEntriesByType('navigation');
      if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
        this.isTabClosed = false;
      } else {
        this.isTabClosed = true;
      }
    },
    logout(tipo) {
      const usuario = JSON.parse(sessionStorage.getItem("user"));
      var registro = null;
      if (usuario != null) {
        registro = {
          id_usuario: usuario.id_usuario,
          logado: 0,
          token: null,
        };
      } else {
        registro = {
          id_usuario: -1,
          logado: 0,
          token: null,
        };
      }
      if (tipo == 0) {
        apiController.request(apiController.endpoints.atualizastatus, {
        data: registro,
        onSuccess: () => {
          sessionStorage.removeItem("user");
            sessionStorage.removeItem("api");
            sessionStorage.removeItem("permissoes");
            sessionStorage.removeItem("home");
            this.show1 = false;
            this.show2 = false;
            this.senha = null;
            this.repetirsenha = null;
            this.alterarSenhaDialog = false;
            this.menuDrawer = false;
            var id = window.setTimeout(function () { }, 0);

            while (id--) {
              window.clearTimeout(id); // will do nothing if no timeout with id is present
            }
            this.$router.push({ path: "/" });
        },
        onError: (e) => {
          console.log(e);
        }
      })
      }
      else {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("api");
        sessionStorage.removeItem("permissoes");
        sessionStorage.removeItem("home");
        this.$router.push({ path: "/" });
      }
    },
    triggerRelatorio(relatorio) {
      if (!this.$route.path.includes('/operacao')) {
        this.$router.push({ path: '/operacao', query: { relatorio: relatorio } });
      } else {
        this.$router.replace({ path: '/operacao', query: { relatorio: relatorio } });
      }
    },
    carregarTicketsAbertos() {
      if (this.user && this.user.id_usuario) {
        apiController.request(apiController.endpoints.getTicketsabertosbyusuario, {
        params: { id: this.user.id_usuario },
        onSuccess: (response) => {
          this.ticketsAbertos = response.data.total_abertos || 0;
        },
        onError: (e) => {
          console.log(this.$t('nav.erro') + ":", e.message);
            this.ticketsAbertos = 0;
        }
      })
      }
    },
    populaSetup() {
      if (this.user && this.user.id_usuario) {
        apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = Object.assign({}, response.data[0]);
        }
      })
      }
    },
    populaConfiguracoes() {

      if (this.user && this.user.id_usuario) {
        apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          const row = response.data && response.data[0];
            const v = row && row.motorista_cria_viagem;
            this.motoristaCriaViagem = Number(v) === 1 ? 1 : 0;
        },
        onError: () => {
          this.motoristaCriaViagem = 0;
        }
      })
      }
    },
    handleLogoClick() {
      const targetPath = resolvePostLoginPath(
        this.$router,
        this.user && this.user.home_page,
        this.user,
        this.permissoes
      );
      if (targetPath) {
        this.$router.push({ path: targetPath });
      }
    },
    setInfoColor(hex) {
      hex = hex.replace(/^#/, '');

      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

      if (luminance > 128) {
        this.colorInfo = "#000000";
      } else {
        this.colorInfo = "#FFFFFF";
      }
    },
    getFlagEmoji(countryCode) {
      const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt());
      return String.fromCodePoint(...codePoints);
    },
    setLocale(locale) {
      this.$i18n.locale = locale.code;
      if (locale.code.includes('-')) {
        this.$vuetify.lang.current = locale.code.split('-')[0];
      } else {
        this.$vuetify.lang.current = locale.code;
      }
      this.$root.$emit('localeChanged', locale.code);
    }
  },
};
</script>

<style>
.menuNavbar {
  z-index: 40000;
}

.position-relative {
  position: relative;
}

.logo:hover {
  cursor: pointer;
}

.navbar-drawer-header {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
